import { call, put } from 'redux-saga/effects';
import Http from '../../../libs/Http';
import config from '../../../../../config';

export function* fetchData(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield put({ $global: true, type: 'FETCH_AMAZON_BALANCES'});
  const [data, balanceSellingAccounts] = yield [
    call(Http.post, '/data/items', {
      body: {
        types: ['amazonAccounts'],
      }
    }),
    config.features.balanceSelling ? call(Http.get, '/data/balanceSellingAccounts') : null,
  ];
  yield put({
    // $global: true,
    type: 'SET_DYNAMIC_FORM_DATA',
    payload: data,
  });
  if (config.features.balanceSelling) {
    yield put({
      // $global: true,
      type: 'SET_BALANCE_SELLING_ACCOUNTS',
      payload: balanceSellingAccounts,
    });
  }

  yield put({ $global: true, type: 'STOP_LOADER' });
}

function trimData(account) {
  return {
    ...account,
    value: account.value && account.value.trim(),
    email: account.email && account.email.trim(),
    password: account.password && account.password.trim(),
    label: account.label && account.label.trim(),
    accountName: account.accountName && account.accountName.trim(),
  };
}

export function* updateData(action) {
  const { payload } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.post, '/data/update', {
    body: {
      data: {
        amazonAccounts: payload.data.amazonAccounts.map(trimData),
      },
    }
  });
  yield put({
    type: 'FETCH_DYNAMIC_FORM_DATA',
  });
  yield put({
    $global: true,
    type: 'FETCH_DYNAMIC_DATA',
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* deleteBalanceSellingAccount(action) {
  const { payload } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.post, '/data/deleteBalanceSellingAccount', {
    body: {
      id: payload.id,
    }
  });
  yield put({
    type: 'FETCH_DYNAMIC_FORM_DATA',
  });
  yield put({
    $global: true,
    type: 'FETCH_DYNAMIC_DATA',
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* updateBalanceSellingAcountBalance(action) {
  const { payload } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.get, '/data/checkGiftBalance', {
    query: {
      id: payload.id,
    }
  });
  yield put({
    type: 'FETCH_DYNAMIC_FORM_DATA',
  });
  yield put({
    $global: true,
    type: 'FETCH_DYNAMIC_DATA',
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

function convertPriceyakCurrency(value) {
  return value === null || value === '' || value === undefined ? null : parseFloat(value || 0) * 100;
}

function convertNumber(value) {
  if (value === null || value === '' || value === undefined) {
    return null;
  }
  return parseFloat(value);
}

export function* saveCsvData(action) {
  const { payload } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.post, '/data/addCsvData', {
    body: {
      data: {
        ...payload,
        balanceSellingAccounts: payload.balanceSellingAccounts.map(account => ({
          ...account,
          max_spend_per_day: convertPriceyakCurrency(account.max_spend_per_day),
          min_order_value: convertPriceyakCurrency(account.min_order_value),
          max_order_value: convertPriceyakCurrency(account.max_order_value),
          max_spend_unshipped: convertPriceyakCurrency(account.max_spend_unshipped),
          max_spend_lifetime: convertPriceyakCurrency(account.max_spend_lifetime),
          max_orders_lifetime: convertNumber(account.max_orders_lifetime),
          ordering_days: convertNumber(account.ordering_days),
          order_gap: convertNumber(account.order_gap),
          max_orders_unshipped: convertNumber(account.max_orders_unshipped),
        }))
      },
    }
  });
  yield put({
    type: 'FETCH_DYNAMIC_FORM_DATA',
  });
  yield put({
    $global: true,
    type: 'FETCH_DYNAMIC_DATA',
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* toggleBalanceSellingAccount(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.post, '/data/toggleBalanceSellingAccount', {
    body: {
      active: payload.active,
      id: payload.id,
    }
  });
  yield put({
    type: 'FETCH_DYNAMIC_FORM_DATA',
  });
  yield put({
    $global: true,
    type: 'FETCH_DYNAMIC_DATA',
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* toggleBalanceSellingAccountPrime(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.post, '/data/togglePrimeBalanceSellingAccount', {
    body: {
      prime: payload.prime,
      id: payload.id,
    }
  });
  yield put({
    type: 'FETCH_DYNAMIC_FORM_DATA',
  });
  yield put({
    $global: true,
    type: 'FETCH_DYNAMIC_DATA',
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* saveBalanceSellingAccount(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.post, '/data/saveBalanceSellingAccount', {
    body: {
      id: payload.id,
      type: payload.type,
      data: {
        ...payload.data,
        max_spend_per_day: convertPriceyakCurrency(payload.data.max_spend_per_day),
        min_order_value: convertPriceyakCurrency(payload.data.min_order_value),
        max_order_value: convertPriceyakCurrency(payload.data.max_order_value),
        max_spend_unshipped: convertPriceyakCurrency(payload.data.max_spend_unshipped),
        max_spend_lifetime: convertPriceyakCurrency(payload.data.max_spend_lifetime),
        max_orders_lifetime: convertNumber(payload.data.max_orders_lifetime),
        ordering_days: convertNumber(payload.data.ordering_days),
        order_gap: convertNumber(payload.data.order_gap),
        max_orders_unshipped: convertNumber(payload.data.max_orders_unshipped),
      },
    }
  });
  yield put({
    type: 'FETCH_DYNAMIC_FORM_DATA',
  });
  yield put({
    $global: true,
    type: 'FETCH_DYNAMIC_DATA',
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export function* removeAmazonBalance(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  yield call(Http.delete, '/data/amazonBalance', {
    query: {
      id: payload._id,
    },
  });
  yield put({
    $global: true,
    type: 'FETCH_AMAZON_BALANCES',
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export default function*({ takeFirst, takeLatest }) {
  yield [
    takeLatest('FETCH_DYNAMIC_FORM_DATA', fetchData),
    takeLatest('UPDATE_DYNAMIC_FORM_DATA', updateData),
    takeLatest('REMOVE_AMAZON_BALANCE', removeAmazonBalance),
    takeLatest('TOGGLE_BALANCE_SELLING_ACCOUNT', toggleBalanceSellingAccount),
    takeLatest('TOGGLE_BALANCE_SELLING_ACCOUNT_PRIME', toggleBalanceSellingAccountPrime),
    takeLatest('SAVE_BALANCE_SELLING_ACCOUNT', saveBalanceSellingAccount),
    takeLatest('SAVE_CSV_DATA', saveCsvData),
    takeLatest('DELETE_BALANCE_SELLING_ACCOUNT', deleteBalanceSellingAccount),
    takeLatest('UPDATE_BALANCE_SELLING_ACCOUNT_BALANCE', updateBalanceSellingAcountBalance),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Data/Data.sagas.js